module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"you_have_insufficient":"You have insufficient credit to perform this transaction. Please reload to proceed."}}')
  delete Component.options._Ctor
}
